import { Fragment } from "react";
import { Route } from "react-router-dom";

import * as C from "./lazyComponents";

export const CustomPageRoutes = (
  <Fragment>
    <Route path={`${process.env.PUBLIC_URL}/pages/themeStyle`} element={<C.Switcherlayout />} />
    <Route path={`${process.env.PUBLIC_URL}/`} element={<C.Custompages />}>
      <Route
        path={`${process.env.PUBLIC_URL}/pages/underConstruction`}
        element={<C.UnderConstruction />}
      />
      <Route path={`${process.env.PUBLIC_URL}/login`} element={<C.Login />} />
      <Route path={`${process.env.PUBLIC_URL}/otp-verification`} element={<C.OtpVerification />} />
      <Route path={`${process.env.PUBLIC_URL}/register`} element={<C.Register />} />
      <Route path={`${process.env.PUBLIC_URL}/forgotPassword`} element={<C.ForgotPassword />} />
      <Route
        path={`${process.env.PUBLIC_URL}/forgot-password-request-success`}
        element={<C.ForgotRequest />}
      />
      <Route path={`${process.env.PUBLIC_URL}/reset-password/:id`} element={<C.PasswordReset />} />
      <Route path={`${process.env.PUBLIC_URL}/custompages/lockScreen`} element={<C.LockScreen />} />
      <Route
        path={`${process.env.PUBLIC_URL}/custompages/errorpages/errorpage401`}
        element={<C.Errorpage401 />}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/custompages/errorpages/errorpage403`}
        element={<C.Errorpage403 />}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/custompages/errorpages/errorpage500`}
        element={<C.Errorpage500 />}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/custompages/errorpages/errorpage503`}
        element={<C.Errorpage503 />}
      />
      <Route path="*" element={<C.Errorpage400 />} />
    </Route>
  </Fragment>
);
